<app-view-loading class="overlay" *ngIf="carregando"></app-view-loading>
<div *ngIf="!logged" class="notLogged">
    <div class="container">
        <nav class="navbar">
            <a class="navbar-brand">
                <img [src]="logolight" style="max-width: 200px;">
            </a>
        </nav>
        <div *ngIf="mostraTelaLogin">
            <h1 class="title">{{projeto != 'MMC' ? ("Descubra o Brasil" | translate) : ("Descubra o Brasil | " + ("Descubra Brasil" | translate))}}</h1>
        </div>
        <div class="loginArea" *ngIf="mostraTelaLogin else telaAutenticacao">

            <div class="row">
                <span class="input-group-text" id="inputGroup-sizing-default">{{projeto != 'MMC' ? ("E-mail" | translate) : ("E-mail | " + ("Correo Electrónico" | translate))}}</span>
                <input type="text" class="form-control" id="username" aria-label="Default"
                    aria-describedby="inputGroup-sizing-default" [(ngModel)]="user.email" #email="ngModel"
                    (keyup.enter)="login()">
            </div>
            <div class="row">
                <span class="input-group-text" id="inputGroup-sizing-default">{{projeto != 'MMC' ? ("Senha" | translate) : ("Senha | " + ("Contraseña" | translate))}}</span>
                <input type="password" class="form-control" aria-label="Default"
                    aria-describedby="inputGroup-sizing-default" [(ngModel)]="user.password" #senha="ngModel"
                    (keyup.enter)="login()">
            </div>
            <div class="row">
                <button type="button" class="btn btn-login" (click)="login()" routerLink="">{{projeto != 'MMC' ? ("Login" | translate) : ("Login | " + ("Iniciar sesión" | translate))}}</button>
            </div>
            <div class="row" id="forgotPassword">
                <a data-bs-toggle="modal" data-bs-target="#recuperarSenha"
                    (click)="recuperarSenha = !recuperarSenha">{{projeto != 'MMC' ? ("Esqueci minha senha" | translate) : ("Esqueci minha senha | " + ("Olvidé mi contraseña" | translate))}}</a>
            </div>
            <div class="row" *ngIf="errors?.length > 0">
               <span *ngFor="let erro of errors" style="color: red; padding-top: 10px; font-weight: 500; font-size: 19px;">{{erro}}</span>
            </div>
        </div>
        <ng-template #telaAutenticacao>
            <app-autenticacao (logado)="logadoOuAutenticado()" (trocaTelaLogin)="trocaDeTela($event)"></app-autenticacao>
        </ng-template>
    </div>
    <app-footer></app-footer>

</div>
<div *ngIf="logged" class="logged">
    <app-header (deslogou)="isLoggedIn()" [usuario]="usuario" *ngIf="!escondeHtml"></app-header>
    <app-navbar *ngIf="!escondeHtml"></app-navbar>
    <router-outlet></router-outlet>
    <app-loader></app-loader>
    <app-footer *ngIf="!escondeHtml"></app-footer>
</div>



<div class="modal fade" id="recuperarSenha" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <app-recuperar-senha></app-recuperar-senha>
        </div>
    </div>
</div>
